module.exports = __webpack_public_path__ + "img/icon_sites.f31e273f.svg";